module.exports = __webpack_public_path__ + "static/media/carta_9.b070fe18.jpg";